import { APIConfigURLs } from "../apiInterfaceType/apiInterfaceType";

const DELETE_API_URL: APIConfigURLs = {
  designationDelete: {
    url: "/hrm/designation/",
  },
  departmentDelete: {
    url: "/hrm/department/",
  },
  departmentSingleDelete: {
    url: "/hrm/department",
  },
  deleteEmployee: {
    url: "/hrm/employee/employeeIds",
  },
  roleDelete: {
    url: "/hrm/role/",
  },
  singleUserDelete: {
    url: "/hrm/user/",
  },
  deleteSalaryMaster: {
    url: "/hrm/salarycomponent",
  },
  deleteAsset: {
    url: "/hrm/asset/employee-asset",
  },
  deleteChapter: {
    url: "/chapter",
    baseURL: "/elms-app-api/v1",
  },
  deleteHoliday: {
    url: "/holiday-detail",
    baseURL: "/admin/leave-management/v1",
  },
  deleteAssignedEmployee: {
    url: "/employee/course/unassign",
    baseURL: "/elms-app-api/v1",
  },
  deleteCertificateToCourse: {
    url: "/coursecertificate/",
    baseURL: "/elms-app-api/v1",
  },
  deleteAnnouncement: {
    url: "hrm/email/announcement/delete",
  },
  deleteLeaveRequest: {
    url: "/employee-api/leave-management/v1/employee/leave-request",
    nonVersion: true,
  },
  missingDocumentDelete: {
    url: "/document/documentDetail",
    baseURL: "/employee-api",
  },
  employeePerformanceNoteDelete: {
    url: "/hrm/performance-notes",
  },

  deleteEmployeeRosterPlan: {
    url: "/hrm/employee-roster-plan",
  },
  deleteEmployeeKpi: {
    url: "/hrm/employee-kpi",
  },
};

export default DELETE_API_URL;

